import React, { useContext } from 'react';
import { ConnectContext } from '../../context/connectContext';
import { Col, Div } from 'atomize';
import { Link } from 'react-router-dom';

const Navbar = () => {
    const { resetContext } = useContext(ConnectContext);
    return (
        <Div
            pos="absolute"
            style={{zIndex:"400"}}
            flexDir="row"
            d="flex"
            p="1rem"
            justify="center"
            align="center"
            flexWrap="wrap"
            w="100%"
        >
            <Col
                pos="absolute"
                top="-2rem"
                left="0"
                style={{zIndex:'999'}}
            >
                <Link
                    to='/'
                    style={{
                        cursor: 'pointer',
                        alignSelf:'center',
                        zIndex:'999'
                    }}
                    onClick={() => resetContext()}
                >
                    <Div>
                        <img
                            src={require('../../images/logo.png')}
                            alt="logo"
                            height="170rem"
                        />
                    </Div>
                </Link>
            </Col>
            <Col
                pos="absolute"
                top="0"
                right="0"
                style={{zIndex:'999'}}
            >
            </Col>
        </Div> 
    )
}

export default Navbar;